/* Component Dependencies */
var contactAdditionalInfoTemplate = require('templates/contactAdditionalInfo.hbs');
var contactAdditionalInfoReslinkTemplate = require('templates/contactAdditionalInfo-reslink.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  
  type: 'contactAdditionalInfo',
  template: {
    'contactAdditionalInfo': contactAdditionalInfoTemplate,
    'contactAdditionalInfo-reslink': contactAdditionalInfoReslinkTemplate
  },
  events: { 
    'blur .js-text-additional-info' : 'sendConatctInfo',
  },
  contactInfo : {},
  bindEvents: function() {
    var _self = this;
    $('.js-text-additional-info-reslink').change(function(){
      if(this.value){
        _self.pubsub.publish('SHOW_CONSENT_CHECKBOX');
      }
      else{
        _self.pubsub.publish('HIDE_CONSENT_CHECKBOX');
      }
    });
    _self.contactInfo.contactAdditionalInfo = $('.js-text-additional-info').val();
    $(document).ready(function() {
			_self.pubsub.publish('UPDATE_FORM_DATA', ['eventAdditionalInfo', _self.contactInfo]);
		});
  },
  sendConatctInfo : function _sendConatctInfo(event){
    var _self = this;
    _self.contactInfo.contactAdditionalInfo = $('.js-text-additional-info').val()
    _self.pubsub.publish('UPDATE_FORM_DATA', ['eventAdditionalInfo', _self.contactInfo]);
  }
});
